import { isWebViewFarmi } from '@b2ag/farmi-app-appro-tools'
import { getConfig } from '@b2ag/micro-front-tools'
import { useFeatureFlipping } from '@b2ag/feature-flipping'
import { createError, useRequestHeader } from '#imports'
import type { RouteLocationNormalized, RouteLocationNormalizedLoaded, NavigationGuardNext } from 'vue-router'

/* ------- MICROFRONT - FARMI APP APPRO ------- */

export const farmiAppApproRoutes = [
  {
    path: '/farmi/app/input/categories',
    name: 'farmi-app-appro-categories',
    component: () => import('@b2ag/micro-front-farmi-app-appro/app'),
    props: () => ({
      microFrontName: 'farmi-app-appro',
      viewName: 'categories',
    }),
    beforeEnter(_to: RouteLocationNormalized, _from: RouteLocationNormalizedLoaded, next: NavigationGuardNext) {
      if (!isWebViewFarmi(useRequestHeader('user-agent'))) throw createError({ statusCode: 404 })
      next()
    },
  },
  {
    path: '/farmi/app/appro/chatbot',
    name: 'farmi-app-appro-chatbot',
    component: () => import('@b2ag/micro-front-farmi-app-appro/app'),
    props: () => ({
      microFrontName: 'farmi-app-appro',
      viewName: 'chatbot',
    }),
    beforeEnter(_to: RouteLocationNormalized, _from: RouteLocationNormalizedLoaded, next: NavigationGuardNext) {
      if (!isWebViewFarmi(useRequestHeader('user-agent'))) throw createError({ statusCode: 404 })
      else next()
    },
    meta: {
      hideHeaderMenu: true,
      showAppHeader: false,
      private: true,
    },
  },
  {
    path: '/farmi/app/appro/analytics',
    name: 'farmi-app-appro-analytics',
    component: () => import('@b2ag/micro-front-farmi-app-appro/app'),
    meta: {
      showAppHeader: false,
    },
    props: () => ({
      microFrontName: 'farmi-app-appro',
      viewName: 'analytics',
    }),
    beforeEnter(_to: RouteLocationNormalized, _from: RouteLocationNormalizedLoaded, next: NavigationGuardNext) {
      const { isCopilotArcDashboardEnabled } = useFeatureFlipping()

      if (
        isWebViewFarmi(useRequestHeader('user-agent')) &&
        getConfig('DASHBOARD_METABASE_APPRO_VIEW_PAGES_ID') &&
        isCopilotArcDashboardEnabled.value
      )
        next()
      else throw createError({ statusCode: 404 })
    },
  },
]
